<div>
    <div *ngFor="let item of maxCiudades"></div>
</div>